import {Component, ViewEncapsulation} from '@angular/core';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:NotFound404PageCmp'));

@Component({
    selector: 'not-found-404-page-cmp',
    template: require('./not-found-404-page.cmp.html'),
    styles: [String(require('./not-found-404-page.cmp.scss'))],
    host: { 'class': 'not-found-404 page' }
})

export class NotFound404PageCmp {
    constructor() {
        //'Construct not found 404 page');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/pages/not-found-404-page.cmp.ts